// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorFallback_errorContainer__bfR5E","btn__wrapper":"ErrorFallback_btn__wrapper__uvvIw"};